<template>
  <el-upload
    action
    :show-file-list="false"
    :http-request="uploadFile"
    :on-success="onSuccess"
    :on-remove="onRemove"
    :on-progress="onProgress"
    :disabled="uploading"
    v-bind="$attrs"
    class="avatar-uploader"
    :class="{isCircle}"
    :style="`width:${width}px;`"
  >
    <div :style="`width:${width}px;height:${width}px`">
      <img v-if="imageUrl" :src="imageUrl" class="avatar" />
      <i
        v-if="(!uploading&&!imageUrl) || disabled"
        :style="`width:${width}px;height:${width}px;line-height:${width}px`"
        class="el-icon-plus avatar-uploader-icon"
      ></i>
      <div v-if="uploading&&!disabled" class="progress">
        <el-progress :width="width" type="circle" :percentage="percentage" />
      </div>
    </div>
    <div v-if="tips" slot="tip" class="tips" :class="{require:requireStar}">{{ tips }}</div>
  </el-upload>
</template>

<script>
import { uploadImage, uploadIdcardImg } from '@/api/user'
import { dispatch } from '@/utils/agreementUtil'
import { mapState } from 'vuex'
export default {
  name: 'CustomUploader',
  props: {
    url: {
      type: String,
      default: ''
    },
    tips: {
      type: String,
      default: ''
    },
    fileType: {
      type: String,
      default: 'tenementSystemConfigImg'
    },
    isCircle: {
      type: Boolean,
      default: false
    },
    isNeedAttachId: {
      type: Boolean,
      default: true
    },
    width: {
      type: Number,
      default: 170
    },
    isIdCard: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    idcardImgType: {
      type: String,
      default: 'front'
    },
    requireStar: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fileList: [],
      realFileList: [],
      imageUrl: '',
      percentage: 0,
      uploading: false
    }
  },
  computed: {
    ...mapState({
      projectItem: state => state.user.projectItem
    })
  },
  watch: {
    url: {
      immediate: true,
      handler(val) {
        this.imageUrl = val
      }
    },
    disabled: {
      immediate: true,
      handler() {
        if (this.disabled) {
          this.uploading = true
        } else {
          this.uploading = false
        }
      }
    }
  },
  methods: {
    onProgress(e) {
      this.percentage = e.percent
    },
    onSuccess(response, file, fileList) {
      this.imageUrl = URL.createObjectURL(file.raw)
      let str = response.filePath
      if (this.isNeedAttachId) {
        str = response.filePath + ',' + response.attachId + ',' + response.fileUrl
      }
      this.$emit('input', str)
      dispatch.call(this, 'ElFormItem', 'el.form.blur', [str])
      this.$emit('success')
      if (this.isIdCard) {
        this.$emit('sendIdCardInfo', response.idcardInfo)
      }
    },
    onRemove() {
      this.$emit('input', '')
    },
    uploadFile(params) {
      const formData = new FormData()
      formData.append('file', params.file)
      formData.append('fileType', this.fileType)
      formData.append('fileType', this.fileType)
      formData.append('targetId', this.projectItem.projectId)
      params.onProgress({ percent: 0 })
      this.uploading = true
      let method = uploadImage
      if (this.isIdCard) {
        method = uploadIdcardImg
        formData.append('idcardImgType ', this.idcardImgType)
      }
      method({
        data: formData,
        processCallBack: progressEvent => {
          params.onProgress({
            percent: (progressEvent.loaded / progressEvent.total) * 100
          })
        }
      }).then(res => {
        params.onSuccess(res.data)
      }).finally(() => {
        this.uploading = false
      })
    },
    clear() {
      this.imageUrl = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.tips{
  display: flex;
  justify-content: center;
  margin: 10px 0;
  margin-bottom: 20px;
  line-height: 1;
}
.require{
  position: relative;
  &::before{
    content: '*';
    color: #ff4949;
    margin-right: 4px;
  }
}
 ::v-deep.avatar-uploader .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
 ::v-deep.isCircle .el-upload {
    border-radius: 50%;
  }

  ::v-deep.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  ::v-deep.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    text-align: center;
  }

   ::v-deep.avatar {
     width: 100%;
     height: 100%;
     display: block;
     object-fit: cover;
  }
  .progress{
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: rgba(255,255,255,.9);
      display: flex;
      justify-content: center;
      align-items: center;
  }
</style>
